import { DateFormatter } from '@repo/toolkit/date'
import { useInstantQuery } from '@repo/toolkit/use-instant-query'
import Badge from '@repo/ui/badge'
import Typography from '@repo/ui/typography'
import { useMutation } from '@tanstack/react-query'
import { toast } from 'sonner'

import { getAffectedStaffEndOfStayReport } from '../../../api/affected-staffs/get-affected-end-of-stay-report'
import { saveAffectedStaffEndOfStayReport } from '../../../api/affected-staffs/save-affected-staff-end-of-stay-report'
import { submitAffectedStaffEndOfStayReport } from '../../../api/affected-staffs/submit-affected-staff-end-of-stay-report'
import LoadingScreen from '../../../components/elements/loading/loading-screen'
import AffectedStaffEndOfStayReportForm from '../../../components/pages/affected-staffs/affected-staff-end-of-stay-report-form'
import { mapAffectedStaffEndOfStayReportToInput } from '../../../components/pages/affected-staffs/utils'
import useAffectedStaff from '../../../lib/hooks/use-affected-staff'
import useTranslate from '../../../lib/hooks/use-translate'

export default function StaffPersonalSpaceJourneyDetailsEndOfStayReport() {
  const { t } = useTranslate()
  const { affectedStaff, isLoading } = useAffectedStaff()

  const report = useInstantQuery({
    queryFn: () => {
      if (!affectedStaff) throw new Error('No affected staff')
      return getAffectedStaffEndOfStayReport(affectedStaff.id)
    },
    enabled: !!affectedStaff
  })

  const saveForLater = useMutation({
    mutationFn: saveAffectedStaffEndOfStayReport,
    onSuccess() {
      toast.success('Rapport sauvegardé avec succès')
    }
  })
  const submit = useMutation({
    mutationFn: submitAffectedStaffEndOfStayReport,
    onSuccess() {
      toast.success('Rapport soumis avec succès')
      report.refetch()
    }
  })

  if (isLoading || report.isPending) return <LoadingScreen />
  if (!affectedStaff) return <Typography variant="text">Affected staff not found</Typography>

  return (
    <div className={'flex flex-col gap-4'}>
      <div className="flex items-center gap-3">
        <Typography variant="h3">
          {t('staff.personal.space.my.journeys.details.end.of.stay.report')}
        </Typography>

        {report.data?.submittedAt && (
          <Badge
            variant="success"
            size="medium"
            text={`Envoyée à LEC le ${DateFormatter.DDMMYYYY(report.data.submittedAt)}`}
          />
        )}
      </div>
      <AffectedStaffEndOfStayReportForm
        readOnly={!!report.data?.isSubmitted}
        defaultValues={report.data ? mapAffectedStaffEndOfStayReportToInput(report.data) : {}}
        handleSubmit={async (data, type) => {
          if (type === 'save-for-later')
            await saveForLater.mutateAsync({ input: data, affectedStaffId: affectedStaff.id })
          else await submit.mutateAsync({ input: data, affectedStaffId: affectedStaff.id })
        }}
      />
    </div>
  )
}
